import { useUsersStore } from "./users";

export function user() {
    return useUsersStore()?.user
}

export function uid(): string {
    return user()?.uid ?? ''
}
